import React from 'react';

import ProductFeature from 'bundles/connect/components/search/components/product_feature';
import OffMarketMapTableViewToggle from 'bundles/connect/components/search/components/off_market_map_table_view_toggle';
import { useDispatch, useSelector } from 'react-redux';
import { selectCallListItems, selectPage, selectTotal } from '../store/selectors/results';
import { setPage, setCallListItems } from '../store/actions/results';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap-5';
import { deleteCallListItems } from 'bundles/connect/helpers/prospect_api';
import { displayToast } from 'bundles/connect/helpers/display_toast';

type CallListOffMarketResultsHeaderProps = {
  selectAll: boolean;
  selectedCallListItemIds: Set<number>;
  onToggleAllSelected: () => void;
}

export default function CallListOffMarketResultsHeader(
  {
    selectAll,
    selectedCallListItemIds,
    onToggleAllSelected
  }: CallListOffMarketResultsHeaderProps
) {
  const dispatch = useDispatch();
  const totalItems = useSelector(selectTotal);
  const callListItems = useSelector(selectCallListItems);
  const page = useSelector(selectPage);

  const handleDelete = () => {
    let idsToDelete: number[] = [];

    if (selectAll) {
      idsToDelete = callListItems.map(item => item.id);
    } else {
      idsToDelete = Array.from(selectedCallListItemIds);
    }

    if (window.confirm('Are you sure you want to delete the selected call list items?')) {
      deleteCallListItems(idsToDelete).then(() => {
        let newPage = selectAll ? page - 1 : page;
        newPage = newPage < 1 ? 2 : newPage;
        const newItems = selectAll ? [] : callListItems.filter(item => !idsToDelete.includes(item.id));

        dispatch(setPage(newPage));
        dispatch(setCallListItems(newItems));
        displayToast('Call list items deleted successfully', 'success');
      });
    }
  };

  return (
    <div
      className="p-3 d-flex align-items-center justify-content-between top-0 position-relative z-3 bg-white shadow-md flex-grow-0"
    >
      <ProductFeature product="prospecting">
        <label className="me-auto">
          <div className="d-flex gap-2">
            <input
              checked={selectAll}
              data-pendo-tag="results_select_all_checkbox"
              disabled={totalItems === 0}
              type="checkbox"
              onChange={onToggleAllSelected}
            />
            <div>Select All</div>
          </div>
        </label>
        {(selectedCallListItemIds.size > 0 || selectAll) ? (
          <OverlayTrigger
            overlay={<Tooltip>Remove Selected</Tooltip>}
            placement="left"
          >
            <FontAwesomeIcon className="text-primary clickable px-4" icon={faTrash} onClick={handleDelete} />
          </OverlayTrigger>
        ) : (
          <FontAwesomeIcon className="text-muted px-4" icon={faTrash} />
        )}
      </ProductFeature>
      <OffMarketMapTableViewToggle />
    </div>
  );
}
